function LegalDE() {
  return (
    <div className="hero hero__secondary position-relative bg-white px-2 px-sm-0">
      <div className="container narrow bg-white rounded-5 p-md-5">
        <h2>Urheberrecht</h2>
        <p>
          Alle auf den Internetseiten von Argeta ver&ouml;ffentlichten Inhalte
          sind Eigentum des Unternehmens ATLANTIC DROGA KOLINSKA d.o.o. und im
          gesetzlich zul&auml;ssigen Rahmen Gegenstand des Urheberrechts oder
          anderer Formen des Schutzes von intellektuellem Eigentum.&nbsp;
          <br />
          <br />
          Die auf diesen Internetseiten ver&ouml;ffentlichten Inhalte (Texte,
          Bilder, Logos etc.), dienen ausschlie&szlig;lich der
          nicht-kommerziellen Nutzung und d&uuml;rfen ohne die
          ausdr&uuml;ckliche Genehmigung des Unternehmens ATLANTIC DROGA
          KOLINSKA d.o.o. weder ver&auml;ndert, kopiert, vervielf&auml;ltigt,
          wiederver&ouml;ffentlicht, postalisch versendet noch anderweitig zu
          kommerziellen Zwecken verbreitet werden.&nbsp;
          <br />
          <br />
          Auch alle Reproduktionen oder Exemplare von Inhalten dieser
          Internetseiten m&uuml;ssen alle angegebenen Kennzeichnungen von
          Urheberrechten und anderen Mitteilungen &uuml;ber die Rechte
          intellektuellen Eigentums oder Mitteilungen &uuml;ber andere Rechte
          aufweisen (Zeichen &copy; 2015 ATLANTIC DROGA KOLINSKA d.o.o. Alle
          Rechte vorbehalten. ATLANTIC DROGA KOLINSKA d.o.o. ist Teil der
          Atlantic Grupa).&nbsp;
          <br />
          <br />
          Warenzeichen und Dienstleistungsmarken, die auf diesen Seiten
          erscheinen, sind registrierte Warenzeichen, deren Eigent&uuml;mer oder
          Lizenznehmer ATLANTIC DROGA KOLINSKA d.o.o. (nachfolgend auch
          Unternehmen) oder seine verbundenen Unternehmen sind. Die Verwendung
          dieser Marken ist ausdr&uuml;cklich verboten, mit Ausnahme in diesem
          Wortlaut definierter F&auml;lle.
        </p>
        <h2>Datenschutzbestimmungen</h2>
        <p>
          ATLANTIC DROGA KOLINSKA d.o.o. (nachfolgend: Gesellschaft) ist ein
          Teil des Gesch&auml;ftssystems der Atlantic Grupa, in dessen Rahmen
          hohe Standards der Gesch&auml;ftsf&uuml;hrung und einer transparenten
          Gesch&auml;ftsabwicklung aufgestellt wurden und angewandt werden,
          unter denen man ein verantwortliches, gesetzeskonformes und ethisch
          begr&uuml;ndetes Verhalten aller Rechtssubjekte der Atlantic Grupa
          versteht, einschlie&szlig;lich der Einhaltung des Schutzes der
          Privatsph&auml;re und des Schutzes personenbezogener Daten.&nbsp;
          <br />
          <br />
          Unter Einhaltung der genannten Standards erhebt und verarbeitet die
          Gesellschaft als Auftragsverarbeiter im Rahmen des
          Gesch&auml;ftssystems der Atlantic Grupa personenbezogene Daten
          gesetzeskonform, fair und transparent, nach den geltenden
          Vorschriften, wobei entsprechende technische und organisatorische
          Ma&szlig;nahmen im Sinne des Schutzes personenbezogener Daten vor
          unbefugtem Zugang und Missbrauch durchgef&uuml;hrt werden.&nbsp;
          <br />
          <br />
          Die Gesellschaft ist sich dessen bewusst, dass der Schutz
          personenbezogener Daten sowohl f&uuml;r ihre Nutzer als auch f&uuml;r
          andere Einzelpersonen wichtig ist. Deshalb m&ouml;chten wir Ihnen
          veranschaulichen, welche personenbezogenen Daten von uns erhoben
          werden, wie wir diese verwalten und wie wir ihren Schutz
          gew&auml;hrleisten.
        </p>
        <h2>Zwecke, Umfang und Rechtsgrundlagen der Datenverarbeitung</h2>
        <p>
          Personenbezogene Daten werden zu besonderen, ausdr&uuml;cklichen und
          gesetzeskonformen Zwecken und im notwendigen Umfang erhoben und auf
          eine diesen Zwecken entsprechende Art und Weise verarbeitet.&nbsp;
          <br />
          <br />
          Die Gesellschaft wird personenbezogene Daten nur in solchen
          F&auml;llen erheben und verarbeiten, in denen dies durch Vorschriften
          gedeckt ist:
        </p>
        <ul>
          <li>
            <p>
              die Verarbeitung muss wegen der Einhaltung von Rechtspflichten
              durchgef&uuml;hrt werden;
            </p>
          </li>
          <li>
            <p>
              der Betroffene hat seine Einwilligung f&uuml;r die Verarbeitung
              seiner personenbezogenen Daten gegeben;
            </p>
          </li>
          <li>
            <p>
              die Verarbeitung ist f&uuml;r die Erf&uuml;llung des Vertrages
              notwendig, in dem der Betroffene Partei ist, oder um bestimmte
              Handlungen auf Antrag des Betroffenen vor Abschluss eines
              Vertrages vorzunehmen;
            </p>
          </li>
          <li>
            <p>
              die Verarbeitung ist notwendig, um die Lebenswichtigen Interessen
              der betroffenen Person oder einer anderen nat&uuml;rlichen Person
              zu sch&uuml;tzen;
            </p>
          </li>
          <li>
            <p>
              die Verarbeitung ist f&uuml;r die legitimen Interessen der
              Gesellschaft oder verbundener Unternehmen notwendig.
            </p>
          </li>
        </ul>
        <h2>Erhebung und Verwendung personenbezogener Daten</h2>
        <p>
          Personenbezogene Daten sind Informationen, die eine Person unmittelbar
          oder mittelbar identifizieren. Dazu z&auml;hlen z. B. Vor- und
          Nachname, E-Mail-Adresse, Telefonnummer, IP-Adresse und
          Postanschrift.&nbsp;
          <br />
          <br />
          Die Gesellschaft erhebt personenbezogenen Daten nur, wenn diese
          ausdr&uuml;cklich vorgelegt worden sind (z. B. Anfrage bez&uuml;glich
          eines bestimmten Produktes oder einer Dienstleistung,
          Vertragsabschluss oder Beantragung bestimmter Handlungen vor
          Vertragsabschluss, Aufnahme in Loyalit&auml;tsprogramme, Anmeldung
          f&uuml;r den Newsletter, Teilnahme an Umfragen, Wettbewerben und
          Gewinnspielen, Bestellung von Proben oder Brosch&uuml;ren,
          Spendenanfragen sowie Einholung von Ausk&uuml;nften, Vorlage eines
          Lebenslaufs oder eines offenen Angebots oder Bewerbungen auf offene
          Stellen sowie Besch&auml;ftigung in unserer Gesellschaft etc.).&nbsp;
          <br />
          <br />
          Die personenbezogenen Daten werden in dem inhaltlichen und zeitlichen
          Umfang erhoben, gespeichert, verwendet oder &uuml;bertragen, der in
          einem bestimmten Fall erforderlich ist, z. B. um die Fragen zu
          beantworten, Anforderungen zu erf&uuml;llen, &uuml;ber unsere
          Produkte, die Ergebnisse eines Wettbewerbs oder eines Gewinnspiels zu
          informieren, die Vertragspflichten zu erf&uuml;llen, unbedingt
          notwendige Handlungen vor dem Vertragsabschluss vorzunehmen oder um
          unseren weiteren gesetzlichen oder rechtlichen Pflichten nachzukommen.
          Aus diesen Gr&uuml;nden muss die Gesellschaft die personenbezogenen
          Daten gelegentlich an andere Unternehmen innerhalb der Atlantic Grupa
          sowie verbundene Unternehmen oder externe Dienstleistungserbringer zur
          weiteren Verarbeitung weiterleiten. Die Dienstleistungserbringer
          k&ouml;nnen beispielsweise im Zusammenhang von
          Call-Center-Dienstleistungen, Versendung von Waren, Verteilung von
          Werbematerial oder f&uuml;r die Veranstaltung und Durchf&uuml;hrung
          von Gewinnspielen eingesetzt werden. Die Gesellschaft fordert von
          diesen Beteiligten die Annahme der geltenden Rechtsvorschriften, die
          Einhaltung ihrer Anweisungen sowie die Konformit&auml;t mit den
          betriebsinternen Regeln zum Schutz personenbezogener Daten und den
          Anspr&uuml;chen auf Anwendung entsprechender organisatorischer und
          technischer Schutzma&szlig;nahmen. Aus diesen Gr&uuml;nden werden wir
          Ihre personenbezogenen Daten gelegentlich auch an andere
          EU-L&auml;nder oder L&auml;nder au&szlig;erhalb der EU &uuml;bertragen
          m&uuml;ssen, wobei die Gesellschaft gew&auml;hrleistet, dass solche
          &Uuml;bertragungen in allem gesetzeskonform und unter Anwendung aller
          verf&uuml;gbaren und angemessenen Ma&szlig;nahmen zum Schutz
          personenbezogener Daten erfolgen.&nbsp;
          <br />
          <br />
          Die Gesellschaft versichert, dass personenbezogenen Daten nicht
          verkauft, verliehen oder in sonstiger Weise an Dritte weitergegeben
          werden, wenn dies nicht dem Zweck entspricht, zu dem diese
          &uuml;bermittelt worden sind. Die Gesellschaft versichert
          &uuml;berdies, dass die Daten an keinen unbefugten Empf&auml;nger
          weitergeleitet werden.&nbsp;
          <br />
          <br />
          Es kann vorkommen, dass wir personenbezogenen Daten an die
          zust&auml;ndige Beh&ouml;rde weiterleiten m&uuml;ssen, soweit dies
          durch das Gesetz oder ein anderes verbindliches Regelwerk angeordnet
          wird.&nbsp;
          <br />
          <br />
          Die erhobenen Daten werden so lange gespeichert, wie es f&uuml;r den
          Erhebungszweck notwendig ist, bzw. bis zu der in den geltenden
          Vorschriften festgelegten Frist.
        </p>
        <h2>
          Verwendung personenbezogener Daten zu Werbe- und Marketingzwecken
        </h2>
        <p>
          Werden personenbezogenen Daten zu Werbe- und Marketingzwecken nach den
          geltenden gesetzlichen Vorschriften auf dem Gebiet des Schutzes
          personenbezogener Daten verwendet, so werden diese Daten zu diesen
          Zwecken gespeichert und verwendet, z. B. zur Versendung von
          Newslettern, Produktproben, Aufforderung zur Teilnahme an Wettbewerben
          und Gewinnspielen, per E-Mail oder Post oder &uuml;ber einen anderen
          Kommunikationskanal, der akzeptiert wurde.&nbsp;
          <br />
          <br />
          Werden personenbezogenen Daten zum Zweck der Versendung von
          individuellem, angepasstem Werbematerial durch Erstellung und
          Verwaltung eines Nutzerprofils verwendet, so wird im Vorfeld, also vor
          der Versendung solchen Werbematerials, dar&uuml;ber informiert. In
          jedem Fall werden von uns vor einer solchen Verarbeitung
          personenbezogener Daten um eine separate, ausdr&uuml;ckliche und
          informierte Einwilligung ersuchen.&nbsp;
          <br />
          <br />
          Daten werden wir je nach Bedarf bei der Auswertung und Verbesserung
          der Effizienz von Internetdienstleistungen, Anzeigen, Marketing,
          Marktforschung und Verkaufsanstrengungen, durch Umfragen oder andere
          Befragungen verwenden oder auf eine Art und Weise, die sicherstellen
          wird, dass diese personenbezogenen Daten anonymisiert werden bzw. dass
          sie in keinen Zusammenhang mit der betroffenen Person gebracht werden
          k&ouml;nnen.
        </p>
        <h2>Geltendmachung der Rechte des Betroffenen</h2>
        <p>
          KJederzeit k&ouml;nnen Informationen &uuml;ber die von uns
          verarbeiteten personenbezogenen Daten angefordert, oder deren
          Berichtigung angefordert werden. Ebenso kann die Beendigung der
          Verwendung oder die L&ouml;schung personenbezogenen Daten oder den
          Widerruf der Einwilligung zu allen oder zu bestimmten Zwecken (es sei
          denn, dies ist nicht m&ouml;glich, z. B. wenn es sich um
          Datenverarbeitung zu statistischen Zwecken handelt, wenn die
          personenbezogenen Daten keine Identifikation erm&ouml;glichen) bzw.
          die &Uuml;bertragung von Daten an einen anderen Auftragsverarbeiter
          unter den gesetzlichen Bedingungen angefordert oder die Abmeldung von
          unserem Informations- und Werbematerial durchf&uuml;hrt werden.&nbsp;
          <br />
          <br />
          Ebenso kann ein Widerspruch gegen die Verwendung von personenbezogenen
          Daten in Situationen eingelegt werden, die auf der Existenz unseres
          legitimen Interesses beruhen, insbesondere dann, wenn sie von uns
          f&uuml;r Zwecke des Direktmarketings verwendet werden.&nbsp;
          <br />
          <br />
          Wir werden unsererseits im h&ouml;chstm&ouml;glichen und sinnvollen
          Ma&szlig;e ber&uuml;cksichtigen, dass die personenbezogenen Daten, die
          uns zur Verf&uuml;gung gestellt wurden, korrekt erfasst werden.
          Dennoch sind auch die Eintragenden selbst f&uuml;r die Richtigkeit
          dieser Daten verantwortlich, weshalb wir darum bitten, sie
          regelm&auml;&szlig;ig und rechtzeitig zu aktualisieren bzw. uns einen
          Antrag auf &Auml;nderung oder Berichtigung zukommen zu lassen.&nbsp;
          <br />
          <br />
          Zur Durchsetzung von Rechte und Pflichten hinsichtlich der Verwendung
          personenbezogener Daten kann sich an die auf der Webseite
          aufgef&uuml;hrte E-Mail-Adresse oder an den Sitz der Gesellschaft oder
          an die E-Mail-Adresse:&nbsp;
          <a href="mailto:dpo@atlanticgrupa.com">dpo@atlanticgrupa.com</a>
          &nbsp;gewendet werden, oder den Anweisungen in den &uuml;bermittelten
          Werbematerialien folgen.&nbsp;
          <br />
          <br />
          Bei der Kontaktaufnahme und der Stellung der genannten Antr&auml;ge
          werden wir sinnvolle Anstrengungen unternehmen, um die Identit&auml;t
          zu best&auml;tigen und eine nicht autorisierte Verarbeitung
          personenbezogener Daten zu verhindern.&nbsp;
          <br />
          <br />
          Nach Erhalt der Antr&auml;ge wird die angeforderte Aktivit&auml;t
          innerhalb einer angemessenen Frist, sp&auml;testens jedoch innerhalb
          von 30 Tagen ab Erhalt durchf&uuml;hrt und je nach Bedarf dar&uuml;ber
          informiert (alles gesetzeskonform).
        </p>
        <h2>Kinder</h2>
        <p>
          In der Regel werden keine Daten &uuml;ber Kinder erhoben. Soweit wir
          uns davon &uuml;berzeugen, dass uns solche Daten ohne Einwilligung der
          Eltern oder der gesetzlichen Betreuer &uuml;bermittelt wurden, werden
          diese schnellstm&ouml;glich gel&ouml;scht. Dabei werden wir uns an die
          Anweisungen halten, die wir von Ihnen als Elternteil oder gesetzlichem
          Betreuer erhalten haben.
        </p>
        <p>
          Sollten wir dennoch f&uuml;r einen bestimmten Zweck Daten &uuml;ber
          Kinder erheben, die in einem Alter sind, in dem nach den geltenden
          Gesetzen eine Einwilligung der Eltern f&uuml;r die Verarbeitung ihrer
          personenbezogenen Daten notwendig ist, werden wir dar&uuml;ber eine
          entsprechende Information ver&ouml;ffentlichen und sinnvolle
          Ma&szlig;nahmen ergreifen, um zu ermitteln, ob die Kinder die
          Einwilligung der Eltern oder der gesetzlichen Betreuer besitzen.
        </p>
        <h2>Datensicherheit</h2>
        <p>
          Wir haben s&auml;mtliche technische und organisatorische
          Ma&szlig;nahmen implementiert, um Verlust, &Auml;nderung, Diebstahl
          oder Zugriff durch unbefugte Dritte bzw. irgendwelche unbefugte
          Verarbeitung Ihrer Daten zu verhindern. Der Zugriff auf Ihre
          personenbezogenen Daten ist lediglich auf jene Mitarbeiter
          beschr&auml;nkt, die diese Informationen Zwecks der Erbringung unserer
          Dienstleistungen bzw. Bearbeitung Ihrer Anfrage ben&ouml;tigen. Wir
          kl&auml;ren unsere Mitarbeiter kontinuierlich &uuml;ber die Bedeutung
          der Datenvertraulichkeit, des Schutzes Ihrer Privatsph&auml;re und des
          Schutzes Ihrer Daten auf. Wir erheben nur solche Daten, die f&uuml;r
          die betreffende Verarbeitung notwendig sind und bewahren sie nicht
          l&auml;nger auf als n&ouml;tig bzw. als gesetzlich vorgesehen.&nbsp;
          <br />
          <br />
          Auf unserer Webseite finden Sie gelegentlich Links auf andere
          Webseiten oder Portale, und wir k&ouml;nnen Ihnen auch Merkmale
          sozialer Netzwerke anbieten, die das Teilen personenbezogener Daten in
          sozialen Netzwerken erm&ouml;glichen. Wir empfehlen Ihnen, sich auf
          jeden Fall zuerst mit den Regeln zum Schutz personenbezogener Daten
          dieser Portale oder sozialer Netzwerke oder Dritter sowie mit den von
          ihnen ergriffenen Sicherheitsma&szlig;nahmen vertraut zu machen, weil
          sich diese von diesen Regeln und den von uns ergriffenen
          Ma&szlig;nahmen unterscheiden k&ouml;nnen, wof&uuml;r wir keine
          Haftung &uuml;bernehmen k&ouml;nnen.
        </p>
        <h2>Haftungseinschr&auml;nkung</h2>
        <p>
          Obwohl wir die uns zur Verf&uuml;gung stehenden technischen,
          organisatorischen und personaltechnischen Ma&szlig;nahmen zum Schutz
          personenbezogener Daten vor zuf&auml;lligem oder vors&auml;tzlichem
          Missbrauch, Vernichtung, Verlust, unbefugten &Auml;nderungen oder
          Zugriffen ergreifen, k&ouml;nnen wir nicht garantieren, dass bestimmte
          personenbezogene Daten, die wir erheben, nicht trotz den Bestimmungen
          dieser Regeln zum Schutz der Privatsph&auml;re zuf&auml;llig
          aufgedeckt werden.&nbsp;
          <br />
          <br />
          Bis zum h&ouml;chsten gesetzlich erlaubten Ma&szlig; wird jegliche
          Haftung f&uuml;r Sch&auml;den ausgeschlossen, die den Nutzern oder
          Dritten durch zuf&auml;llige Aufdeckung personenbezogener Daten
          zugef&uuml;gt werden.&nbsp;
          <br />
          <br />
          Da wir keine Kontrolle &uuml;ber die personenbezogenen Daten haben,
          die Sie beim Besuch oder der Verwendung anderer Portale bzw. direkt an
          Dritte &uuml;bermitteln (z. B. bei der Teilnahme an gesponserten
          Aktivit&auml;ten), schlie&szlig;en wir bis zum h&ouml;chsten
          gesetzlich erlaubten Ma&szlig; die Haftung f&uuml;r Sch&auml;den aus,
          die Ihnen oder Dritten aufgrund der &Uuml;bermittlung der
          personenbezogenen Daten entstehen k&ouml;nnen.
        </p>
        <h2>Aktualisierungen und &Auml;nderungen</h2>
        <p>
          Wir behalten uns das Recht vor, Teile dieser Regeln jederzeit und ohne
          vorherige Ank&uuml;ndigung zu &auml;ndern oder zu aktualisieren.
          Besuchen Sie unsere Webseite von Zeit zu Zeit, um sich mit eventuellen
          &Auml;nderungen oder Aktualisierungen dieser Regeln vertraut zu
          machen. Der Zeitpunkt des Inkrafttretens der aktuellen Fassung der
          Regeln wird von uns angeben.
        </p>
        <p>Diese Regeln wurden zuletzt am 4.2.2020 aktualisiert.</p>
      </div>
    </div>
  );
}

export default LegalDE;
